import React, { useEffect, useState } from 'react';
import AuthentificationApi from '../../api/AuthentificationApi';
import '../../fichierCss/FormulaireMotDePasseOublie.css';

interface FormulaireMotDePasseOublieProps {
  ouvert: boolean;
  fermeture: () => void;
}

const FormulaireMotDePasseOublie = ({ ouvert, fermeture }: FormulaireMotDePasseOublieProps) => {
  const [courriel, setCourriel] = useState('');
  const [chargement, setChargement] = useState(false);
  const [erreur, setErreur] = useState('');
  const [succes, setSucces] = useState('');

  useEffect(() => {
    if (!ouvert) {
      return undefined;
    }

    const gererTouche = (event) => {
      if (event.key === 'Escape') {
        fermeture();
      }
    };

    window.addEventListener('keydown', gererTouche);

    return () => {
      window.removeEventListener('keydown', gererTouche);
    };
  }, [ouvert, fermeture]);

  if (!ouvert) {
    return null;
  }

  const soumettreMotDePasseOublie = async (event) => {
    event.preventDefault();
    setErreur('');
    setSucces('');
    setChargement(true);

    try {
      await AuthentificationApi.motDePasseOublie({ courriel });

      setSucces('Lien de reinitialisation envoye a votre courriel. Verifiez votre boite de reception.');
      setCourriel('');

      setTimeout(() => {
        fermeture();
      }, 3000);
    } catch (exception) {
      // Ne pas révéler si l'email existe ou non pour des raisons de sécurité
      setSucces('Si ce courriel est enregistre, vous recevrez un lien de reinitialisation.');

      setTimeout(() => {
        fermeture();
      }, 2000);
    } finally {
      setChargement(false);
    }
  };

  return (
    <div
      className="mdp-oublie-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="titre-mdp-oublie"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          fermeture();
        }
      }}
    >
      <div className="mdp-oublie-modal-card">
        <button
          type="button"
          className="mdp-oublie-close"
          onClick={fermeture}
          aria-label="Fermer"
        >
          ×
        </button>

        <div className="mdp-oublie-badge">Recuperation</div>
        <h2 id="titre-mdp-oublie">Reinitialiser votre mot de passe</h2>
        <p className="mdp-oublie-subtitle">Entrez votre courriel pour recevoir un lien de reinitialisation.</p>

        <form className="mdp-oublie-form" onSubmit={soumettreMotDePasseOublie}>
          <label htmlFor="courriel-mdp-oublie">Courriel</label>
          <input
            id="courriel-mdp-oublie"
            type="email"
            value={courriel}
            onChange={(event) => setCourriel(event.target.value)}
            placeholder="votre@courriel.com"
            required
          />

          {erreur && <div className="mdp-oublie-feedback erreur">{erreur}</div>}
          {succes && <div className="mdp-oublie-feedback succes">{succes}</div>}

          <button type="submit" className="mdp-oublie-submit" disabled={chargement}>
            {chargement ? 'Envoi en cours...' : 'Envoyer le lien'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default FormulaireMotDePasseOublie;
